<template>
  <div v-if="buttons" class="add-buttons">
    <div class="actions">
      <div
        v-for="button in buttons"
        :key="button.name"
        class="action"
        v-if="can(button)"
      >
        <router-link v-if="button.action == 'link'" :to="button.href">
          <button
            v-if="button.show"
            :disabled="button.disabled"
            @click="action(button)"
            :data-action="button.action"
            class="btn"
            :class="button.classes"
            :id="button.action"
          >
            <span v-if="button.icon" class="icon">
              <img
                src="../../../assets/arrow_left.svg"
                v-if="button.icon == 'arrow_left'"
              />
              <img
                src="../../../assets/arrow_right.svg"
                v-if="button.icon == 'arrow_right'"
              />
            </span>
            <div v-else>
              {{ $t("ui.button." + button.action) }}
            </div>
          </button>
        </router-link>

        <button
          v-else-if="button.action != 'link'"
          :disabled="button.disabled"
          @click="action(button)"
          :data-action="button.action"
          class="btn"
          :class="button.classes"
          :id="button.action"
        >
          <span v-if="button.icon" class="icon">
            <img
              src="../../../assets/import.svg"
              v-if="button.icon == 'import'"
            />
          </span>
          <div v-else>
            {{ $t("ui.button." + button.action) }}
          </div>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Permission from "@/classes/Permission";
import { EventBus } from "@/EventBus.js";
import Permissions from "@/classes/Permission";

export default {
  data() {
    return {
    }
  },
  props: {
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    buttons() {
      return this.$store.getters.getHeaderButtons;
    }
  },
  methods: {
    allowedAccess(button) {
      if (button.access) {
        return Permissions.planCan(button.access);
      } else {
        return true;
      }
    },
    action(button) {
      // define event name, fallback to 'action' if none used

      let event_name = "action";
      if (button.event_name) {
        event_name = button.event_name;
      }

      if (button.access) {
        if (!this.allowedAccess(button)) {
          this.$store.commit("SET_NOT_ALLOWED_MODAL_SHOWN", true);
          return;
        }
      }
      if (button.function) {
        button.function();
        return;
      }
      if (button.action.includes(".new")) {
        this.$router.push({ name: button.name + "_new" });
      } else {
        // check debouncing
        if (button.debounce) {
          document.getElementById(button.action).disabled = true;

          EventBus.$emit(event_name, button.action);
          setTimeout(() => {
            document.getElementById(button.action).disabled = false;
          }, button.debounce);
        } else {
          EventBus.$emit(event_name, button.action);
        }
      }
    },
    can(button) {
      // hide button if its not supposed to be shown (e.g. due to the parent component telling so)
      if (button.show == false) {
        return false;
      }

      let permission = Permission.loadPermissions();
      return Permission.can(permission, button.action);
    }
  }
};
</script>

<style lang="scss">
.add-buttons {
  .icon {
    vertical-align: baseline !important;
  }
  .hidden {
    display: none;
  }
  .actions {
    white-space: nowrap;

    .action {
      display: inline-block;
      margin-right: 1em;

      &:last-child {
        margin-right: 0;
      }

      button {
        &.btn-delete {
          background-color: transparent;
          color: #dd6b50; 
          font-size: 14px;
          border: 0;
          padding: 0;
        }
      }

      .q-btn {
        display: inline;
        padding: 0 1em;
      }
    }
  }
  @include respond-to("small") {
    span[data-action="project_leads.export"] {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// AddButton.vue?74340a32